(() => {
  document.documentElement.classList.remove('no-js');
  const loader = document.querySelector('[data-maestro-loader]');
  if (loader) window.setTimeout(() => loader.classList.add('is-done'), 850);

  const reveals = document.querySelectorAll('.m-reveal');
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    }), { threshold: .12, rootMargin:'0px 0px -35px 0px' });
    reveals.forEach(el => obs.observe(el));
  } else reveals.forEach(el => el.classList.add('is-visible'));

  const menu = document.querySelector('[data-m-menu]');
  const mobile = document.querySelector('[data-m-mobile]');
  if (menu && mobile) {
    menu.addEventListener('click', () => {
      const open = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', String(!open));
      mobile.classList.toggle('is-open', !open);
      document.body.classList.toggle('is-menu-open', !open);
    });
    mobile.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      mobile.classList.remove('is-open'); menu.setAttribute('aria-expanded','false'); document.body.classList.remove('is-menu-open');
    }));
  }

  const header = document.querySelector('[data-m-header]');
  if (header) {
    let last = window.scrollY;
    addEventListener('scroll', () => {
      const y = scrollY;
      if (y > last && y > 360 && !document.body.classList.contains('is-menu-open')) header.style.transform='translateY(-100%)';
      else header.style.transform='translateY(0)';
      last=y;
    }, {passive:true});
  }

  document.querySelectorAll('[data-gallery-thumb][data-src]').forEach(btn => btn.addEventListener('click', () => {
    const gallery = btn.closest('.m-product-gallery');
    const main = gallery?.querySelector('[data-gallery-main] img');
    if (main) {
      main.src = btn.dataset.src;
      main.removeAttribute('srcset');
      main.classList.toggle('m-frame-image--contain', btn.dataset.fit === 'contain');
    }
    gallery?.querySelectorAll('[data-gallery-thumb]').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
  }));

  document.querySelectorAll('[data-product-module]').forEach(module => {
    const json = module.querySelector('[data-product-json]');
    const select = module.querySelector('[data-variant-select]');
    const variantInput = module.querySelector('[data-variant-id]');
    const price = module.querySelector('[data-price]');
    const add = module.querySelector('[data-add]');
    const stock = module.querySelector('.m-stock');
    const stockMessage = module.querySelector('[data-stock-message]');

    if (!json || !variantInput) return;

    let product;
    try {
      product = JSON.parse(json.textContent);
    } catch (e) {
      console.error('MAESTRO: product variant data could not be read.', e);
      return;
    }

    const optionGroups = [...module.querySelectorAll('[data-option-index]')];
    const normalize = value => String(value ?? '').trim();

    const findVariant = options => product.variants.find(variant =>
      variant.options.length === options.length &&
      variant.options.every((value, index) =>
        normalize(value) === normalize(options[index])
      )
    );

    const liquidVariant = product.variants.find(
      variant => String(variant.id) === String(variantInput.value)
    );

    const urlVariantId = location.pathname.includes('/products/')
      ? new URL(location.href).searchParams.get('variant')
      : null;

    const urlVariant = urlVariantId
      ? product.variants.find(variant => String(variant.id) === String(urlVariantId))
      : null;

    // If Shopify/Liquid already selected a variant, respect it.
    // Otherwise use the first visible option in every group (for MAESTRO this is XS + Black),
    // even when that exact variant is sold out. We never silently jump to S.
    const visibleFirstOptions = optionGroups.map(group => {
      const first = group.querySelector('[data-option-value]');
      return first ? normalize(first.dataset.optionValue) : '';
    });

    const visibleFirstVariant = visibleFirstOptions.length &&
      visibleFirstOptions.every(Boolean)
        ? findVariant(visibleFirstOptions)
        : null;

    const initialVariant =
      urlVariant ||
      liquidVariant ||
      visibleFirstVariant ||
      product.variants[0] ||
      null;

    let selectedOptions = initialVariant
      ? initialVariant.options.map(normalize)
      : visibleFirstOptions;

    const setStockMessage = variant => {
      const unavailable = !variant || !variant.available;

      if (stockMessage) {
        stockMessage.hidden = !unavailable;
        stockMessage.textContent = variant ? 'Out of stock' : 'Size unavailable';
      }

      module.classList.toggle('has-unavailable-variant', unavailable);
    };

    const syncButtons = () => {
      optionGroups.forEach((group, groupIndex) => {
        const selected = normalize(selectedOptions[groupIndex]);

        group.querySelectorAll('[data-option-value]').forEach(button => {
          const active = normalize(button.dataset.optionValue) === selected;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    };

    const refreshAvailability = () => {
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach(button => {
          const candidate = [...selectedOptions];
          candidate[groupIndex] = normalize(button.dataset.optionValue);

          const matchingVariant = findVariant(candidate);
          const unavailable = !matchingVariant || !matchingVariant.available;

          button.classList.toggle('is-unavailable', unavailable);
          button.dataset.available = unavailable ? 'false' : 'true';
          button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

          if (unavailable) button.setAttribute('title', 'Out of stock');
          else button.removeAttribute('title');
        });
      });
    };

    const applyVariant = (variant, updateUrl = true) => {
      if (!variant) {
        if (add) {
          add.disabled = true;
          add.textContent = 'SIZE UNAVAILABLE';
        }
        if (stock) stock.textContent = '● UNAVAILABLE';
        setStockMessage(null);
        refreshAvailability();
        return false;
      }

      // This hidden name="id" field is the exact variant Shopify receives.
      variantInput.value = String(variant.id);
      variantInput.setAttribute('value', String(variant.id));

      if (select) select.value = String(variant.id);

      module.dataset.selectedVariantId = String(variant.id);
      module.dataset.selectedVariantTitle = variant.title || '';

      if (price) price.textContent = money(variant.price);

      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available
          ? `ADD TO CART — ${money(variant.price)}`
          : 'OUT OF STOCK';
      }

      if (stock) {
        stock.textContent = variant.available ? '● IN STOCK' : '● OUT OF STOCK';
      }

      setStockMessage(variant);

      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(variant.price);

      if (
        updateUrl &&
        history.replaceState &&
        location.pathname.includes('/products/')
      ) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }

      refreshAvailability();
      return true;
    };

    const chooseOption = (groupIndex, value) => {
      selectedOptions[groupIndex] = normalize(value);
      syncButtons();

      const exactVariant = findVariant(selectedOptions);

      // Never choose a different size automatically.
      // A sold-out M remains M and simply shows Out of stock.
      applyVariant(exactVariant, true);
    };

    optionGroups.forEach((group, fallbackIndex) => {
      const parsedIndex = Number(group.dataset.optionIndex);
      const groupIndex = Number.isInteger(parsedIndex) ? parsedIndex : fallbackIndex;

      group.querySelectorAll('[data-option-value]').forEach(button => {
        button.addEventListener('click', () => {
          chooseOption(groupIndex, button.dataset.optionValue);
        });
      });
    });

    if (initialVariant) {
      selectedOptions = initialVariant.options.map(normalize);
      syncButtons();
      applyVariant(initialVariant, false);
    } else {
      syncButtons();
      refreshAvailability();
      setStockMessage(null);
    }

    // Final cart safeguard: rebuild the exact chosen combination immediately
    // before Shopify receives the product form.
    const form =
      module.querySelector('form[action*="/cart/add"]') ||
      variantInput.closest('form');

    if (form) {
      form.addEventListener('submit', event => {
        const exactVariant = findVariant(selectedOptions);

        if (!exactVariant || !exactVariant.available) {
          event.preventDefault();

          if (add) {
            add.disabled = true;
            add.textContent = exactVariant ? 'OUT OF STOCK' : 'SELECT A SIZE';
          }

          setStockMessage(exactVariant);
          return;
        }

        variantInput.value = String(exactVariant.id);
        variantInput.setAttribute('value', String(exactVariant.id));
        if (select) select.value = String(exactVariant.id);
      });
    }

    function money(cents) {
      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-BE',
          {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'EUR'
          }
        ).format(cents / 100);
      } catch (e) {
        return `€${(cents / 100).toFixed(2)}`;
      }
    }
  });

  document.querySelectorAll('[data-qty-minus]').forEach(btn => btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('[data-qty]');
    if (input) input.value = Math.max(1, Math.floor(Number(input.value) || 1) - 1);
  }));
  document.querySelectorAll('[data-qty-plus]').forEach(btn => btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('[data-qty]');
    if (input) input.value = Math.max(1, Math.floor(Number(input.value) || 1) + 1);
  }));
  document.querySelectorAll('[data-qty]').forEach(input => input.addEventListener('change', () => {
    input.value = Math.max(1, Math.floor(Number(input.value) || 1));
  }));

  const modal = document.querySelector('[data-size-modal]');
  const openModal = () => { if(!modal) return; modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.body.classList.add('is-modal-open'); };
  const closeModal = () => { if(!modal) return; modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); document.body.classList.remove('is-modal-open'); };
  document.querySelectorAll('[data-size-open]').forEach(b => b.addEventListener('click', openModal));
  document.querySelectorAll('[data-size-close]').forEach(b => b.addEventListener('click', closeModal));
  addEventListener('keydown', e => { if(e.key==='Escape') closeModal(); });

  document.querySelectorAll('[data-scroll-buy]').forEach(btn => btn.addEventListener('click', () => document.querySelector('#shop')?.scrollIntoView({behavior:'smooth'})));
  const sticky = document.querySelector('[data-sticky-buy]');
  const shop = document.querySelector('#shop');
  if (sticky && shop && 'IntersectionObserver' in window) {
    const so = new IntersectionObserver(entries => entries.forEach(e => sticky.classList.toggle('is-visible', !e.isIntersecting && scrollY > shop.offsetTop)), {threshold:.08});
    so.observe(shop);
  }
})();


// MAESTRO V4 hero parallax effect
(function(){
  const cards=document.querySelectorAll("[data-tilt-card]");
  cards.forEach(card=>{
    const layers=[...card.querySelectorAll("[data-layer]")];
    const reset=()=>{card.style.transform="perspective(1400px) rotateX(0deg) rotateY(0deg) scale(1)";layers.forEach(layer=>{layer.style.transform="translate3d(0,0,0)"});card.classList.remove("is-hovered")};
    card.addEventListener("mousemove",e=>{
      const rect=card.getBoundingClientRect();
      const px=(e.clientX-rect.left)/rect.width;
      const py=(e.clientY-rect.top)/rect.height;
      const rx=(0.5-py)*12;
      const ry=(px-0.5)*16;
      card.style.transform=`perspective(1400px) rotateX(${rx}deg) rotateY(${ry}deg) scale(1.015)`;
      layers.forEach(layer=>{const depth=Number(layer.dataset.layer||0);const tx=(px-0.5)*(depth/3.4);const ty=(py-0.5)*(depth/3.4);layer.style.transform=`translate3d(${tx}px,${ty}px,${depth}px)`});
      card.classList.add("is-hovered");
    });
    card.addEventListener("mouseleave",reset);
    card.addEventListener("blur",reset);
  });
})();

// MAESTRO V12 cart quantity controls
(() => {
  document.querySelectorAll('[data-cart-qty]').forEach(control => {
    const input = control.querySelector('[data-cart-input]');
    const minus = control.querySelector('[data-cart-minus]');
    const plus = control.querySelector('[data-cart-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      input.value = Math.max(0, Math.floor(Number(input.value) || 0) - 1);
    });
    plus?.addEventListener('click', () => {
      input.value = Math.max(0, Math.floor(Number(input.value) || 0) + 1);
    });
    input.addEventListener('change', () => {
      input.value = Math.max(0, Math.floor(Number(input.value) || 0));
    });
  });
})();
